export default "__VITE_ASSET__Co8zZTXy__"